// src/components/EscapeToHome.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EscapeToHome() {
    const navigate = useNavigate();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                navigate('/'); // Redirect to home
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [navigate]);

    return null; // No UI needed
}